export var agentToProps = _ref => {
  var profilePhoto = _ref.profilePhoto,
    name = _ref.name,
    phone = _ref.phone,
    profileUrl = _ref.profileUrl,
    agentId = _ref.agentId,
    agency = _ref.agency,
    awards = _ref.awards;
  return {
    profilePhoto,
    name,
    phone: phone || (agency === null || agency === void 0 ? void 0 : agency.phone),
    profileUrl,
    id: agentId,
    awards
  };
};
var AgentMap = {
  AGENT: 'Agent',
  PRIVATE_LISTER: 'PrivateLister',
  DEFAULT: 'Unknown'
};
export var agentType = function agentType() {
  var _ref2 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
    type = _ref2.type;
  return AgentMap[type] || AgentMap.DEFAULT;
};
export var agencyToProps = agency => {
  var _agency$images;
  return {
    id: agency.agencyId,
    flags: agency.flags,
    name: agency.name,
    phone: agency.phone,
    logoBackground: agency.logoBackgroundColour,
    logo: (_agency$images = agency.images) === null || _agency$images === void 0 ? void 0 : _agency$images.logo,
    profileUrl: agency.profileUrl
  };
};